import i18n from 'services/base/i18n';

export default {
  // Label that displays the maximum download speed for the network
  download: () => i18n.pgettext('Pages|Bandwidth Prioritization|Box', 'DOWNLOAD'),
  // Label that displays the maximum upload speed for the network
  upload: () => i18n.pgettext('Pages|Bandwidth Prioritization|Box', 'UPLOAD'),
};
